import React from "react";
import { Link } from "@bloomberg/media-ui-article";

import styles from "./styles.module.css";

export default function TipTout() {
    const contactUrl = "https://www.bloomberg.com/tips/";
    return (
        <div className={styles.tipToutContainer}>
            <Link href={contactUrl} target="_blank">
                <span className={styles.tipToutCopy}>Confidential tip?</span>
                <div className={styles.tipToutLink}>
                    Send a tip to our reporters
                </div>
            </Link>
        </div>
    );
}
